import React, {FC} from 'react'

import cn from 'classnames/bind'

import LandingsTitle from 'components/blocks/LandingsTitle'
import PortableBlocks from 'components/blocks/PortableBlocks'
import {Container, Row, Col} from 'components/elements/grid'
import {IMake1099Content} from 'pages/make-your-1099'

import s from './Make1099Mistakes.module.scss'
const cx = cn.bind(s)

interface IMake1099MistakesProps {
	className?: string
	content: IMake1099Content['mistakes']
}

/** Make1099Mistakes block component */
const Make1099Mistakes: FC<IMake1099MistakesProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} subtitle={content?.description} />
				<Row>
					<Col>
						<div className={s.blocks}>
							{content?.items?.map(
								(item) =>
									item.content && <PortableBlocks key={item._key} blockContent={item.content} />,
							)}
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

Make1099Mistakes.displayName = 'Make1099Mistakes'

export default Make1099Mistakes
